export default [
    // *===============================================---*
    // *--------- USER ---- ---------------------------------------*
    // *===============================================---*
    {
        path: '/company/users/edit/:id',
        name: 'apps-users-edit',
        component: () => import('@/views/company/user/users-edit/UsersEdit.vue'),
    },
]